<template>
    <div class="wraper">
        <div v-if="course == null"  v-loading="loading">
        </div>
        <div v-else>
            <el-row style="margin-top:10px">
                <el-col :xs="24" :md="6">
                    <img id="img-courses" src="@/assets/images/courseDefault.png" alt="">
                </el-col>
                <el-col :xs="24" :md="18" id="course-container">
                    <el-row >
                        <el-col :xs="24" :sm="24" :md="18" id="top-section-view">
                            <h1 id="myCourse-name">{{ course.name }}</h1>
                            <complete-porcent  :courseId="course._id"></complete-porcent>
                            <div>
                                    <course-score  :courseId="course._id"></course-score>
                            </div>
                            <router-link id="program-link" :to="{ name: 'Program', params: { id: course._id } }" > Ver Programa </router-link>                     
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6">
                            <button-continue :courseId="course._id"></button-continue>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import completePorcent from '@/components/courses/completePorcent'
import courseScore from '@/components/courses/courseScore'
import buttonContinue from '@/components/courses/buttonContinue'
import { getCourse } from '@/requests/courses'
import { getInscriptionByCourse } from '@/requests/inscriptions'
import { getLecturesByCourse } from '@/requests/lectures'
export default {
    props: [ 'courseId' ],
    components: { completePorcent, courseScore, buttonContinue },
    data(){
        return { 
            loading: false,
            course: null,
        }
    },
    mounted() {
        var count = 0
        getCourse({ id: this.courseId })
        .then((respuesta)=>{
    
            getInscriptionByCourse({ userId: this.$session.get('userId'), courseId: this.courseId })
            .then((response)=>{
                let ins = response.items[0]
                if(ins){
                    if(!ins.isApproved){
                        getLecturesByCourse({ id: this.courseId })
                        .then((lec)=>{
                            for (let i = 0; i < lec.items.length; i++) {
                                if(lec.items[i].type == 'exam'){
                                    for (let e = 0; e < ins.examTries.length; e++) {
                                        if(ins.examTries[e] == lec.items[i]._id){
                                            count++
                                        }
                                        
                                    }
                                    if(count != respuesta.maxExamRetries){
                                       this.course = respuesta
                                    }
                                    
                                }
                                
                            }
                            
                        })
                        
                    }
                    
                }
                this.loading = false
            })
        })
    }
    
}
</script>

<style scpoed>
    
</style>



// WEBPACK FOOTER //
// src/components/courses/myCourses/viewInprogress.vue